// Which step of the funnel this page is, in the admin's words (SSOT, golden rule #1).
//
// ⚠ READ FROM THE REGISTRY, not from the address: a page has three names, one per language
// (`estimation`, `estimate`, `estimacion`), and recognising them by hand would mean keeping a
// fourth list that would age on its own.
//
// It lived inside clarity.js until a second measurement needed the same answer (clicks.js,
// 2026-10-20). A map of the funnel's own vocabulary, copied twice, is how the admin ends up
// told that two different things happened on the same page.

/** The registry's pages, in the admin's words. */
const STEPS = Object.freeze({
  quote: 'devis',
  checkout: 'reservation',
  welcome: 'espace',
  quotePending: 'devis',
  sharedQuote: 'devis',
});

/**
 * The funnel step we are on.
 *
 * @returns {string} the admin's word, or '' for a page the funnel does not count
 */
export function currentStep() {
  const registry = window.PAGE_REGISTRY;
  if (!registry) return '';
  const slug = location.pathname.split('/').filter(Boolean).pop() ?? '';
  const entry = Object.entries(registry.pages ?? {}).find(([, page]) =>
    Object.values(page.slugs ?? {}).includes(slug)
  );
  const name = entry?.[0] ?? '';
  // Capture is a STATE of the estimate page, not a page of its own — the admin counts it as
  // a step all the same.
  if (name === 'estimate') {
    return new URLSearchParams(location.search).get('step') === 'capture'
      ? 'capture'
      : 'formulaire';
  }
  return STEPS[name] ?? '';
}
